import React, {useMemo, useState} from "react";
import {Table, Button, Flex, Tooltip, Modal, Space, Empty} from "antd";
import {
    EditOutlined,
    SearchOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined, CheckCircleOutlined, CheckCircleFilled,
} from "@ant-design/icons";

import {toast} from "react-toastify";
import {axiosInstance} from "../../../api/axiosInstance";
import dayjs from "dayjs";

const TasksTable = ({
                       tableData,
                       fetchPost,
                       fetchTasks,
                       setChildKey,
                       setRowData,
                       setShowModal,
                   }) => {
    const [arrow, setArrow] = useState("Show");
    const mergedArrow = useMemo(() => {
        if (arrow === "Hide") {
            return false;
        }

        if (arrow === "Show") {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);


    const rowClassName = (record, index) => {
        if (record.done) {
            return 'done';
        } else {
            return "not-done"
        }
    };


    const confirm = (id) => {
        Modal.confirm({
            title: "Potvrda",
            icon: <ExclamationCircleOutlined/>,
            content: "Jeste li sigurni da želite obrisati zadatak?",
            okText: "Da",
            cancelText: "Ne",
            centered: true,
            onOk: () => {
                axiosInstance.delete(`/api/v1/task/${id}`)
                    .then(res => {
                        toast.success("Zadatak je uspješno obrisan!");
                        fetchTasks();
                    }).catch(ex => {
                    toast.error(`${ex.response.data.errorMessage}`);
                })
            },
        });
    };

    return (
        <>
            {tableData &&
                tableData.groupedTasks &&
                Object.values(tableData.groupedTasks).map((task, index) => (
                    <div key={index}>
                        <h3>
                            {task[0]?.projectName
                                ? `${task[0].projectName} (investitor: ${task[0].investorName})`
                                : `Javno`}
                        </h3>
                        <Table
                            rowClassName={rowClassName}
                            components={{
                                body: {
                                    row: ({className, ...props}) => {
                                        let tClassName = className.split(" ")[2]
                                        let currentStyle;
                                        switch (tClassName) {
                                            case 'done':
                                                currentStyle = {
                                                    backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIW2NkYGCQBAAAIwAbDJgTxgAAAABJRU5ErkJggg==)",
                                                    backgroundRepeat: "repeat-x",
                                                    backgroundPosition: "50% 50%",
                                                    color: 'black'
                                                };
                                                currentStyle = {
                                                    textDecoration: 'line-through'
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                        return (
                                            <tr
                                                {...props}
                                                style={
                                                    currentStyle
                                                }
                                            />
                                        )
                                    }
                                },
                            }}
                            scroll={{x: 700}}
                            size={"small"}
                            bordered={true}
                            rowKey={"id"}
                            columns={[
                                {
                                    title: "Poruka",
                                    dataIndex: "text",
                                    key: "text",
                                    width: "40%",
                                    render: (value, record, index) => {
                                        return <div style={{
                                            padding: '20px',
                                            width: '600px'
                                        }}>{value ? value : "-"}</div>;
                                    },
                                },
                                {
                                    title: "Tip poruke",
                                    dataIndex: "likeType",
                                    key: "likeType",
                                    align: "center",
                                    render: (value, record, index) => {
                                        return <p>{value ? value : "-"}</p>;
                                    },
                                },
                                {
                                    title: "Datum kreiranja zadatka",
                                    dataIndex: "createdAt",
                                    key: "createdAt",
                                    align: "center",
                                    render: (value, record, index) => {
                                        return <p>{value ? dayjs(value).format("DD.MM.YYYY. HH:mm") : "-"}</p>;
                                    },
                                },
                                {
                                    title: "",
                                    key: "operation",
                                    //fixed: "right",
                                    width: "150px",
                                    render: (text, record, index) => (
                                        <Flex vertical={false} gap={"4px"}>
                                            <Tooltip
                                                placement="top"
                                                title={<span>Pregled objave</span>}
                                                arrow={mergedArrow}
                                            >
                                                <Button
                                                    type="text"
                                                    size="large"
                                                    icon={<SearchOutlined/>}
                                                    onClick={() => {
                                                        setChildKey(prevKey => prevKey + 1);
                                                        setRowData(record);
                                                        fetchPost(record.likeableId, record.likeType)
                                                        setShowModal(true);
                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip
                                                placement="top"
                                                title={
                                                    <span>{!record.done ? "Postavi zadatak kao izvršen" : "Postavi zadatak kao neizvršen"}</span>}
                                                arrow={mergedArrow}
                                            >
                                                <Button
                                                    type="text"
                                                    size="large"
                                                    icon={!record.done ? <CheckCircleOutlined/> :
                                                        <CheckCircleFilled/>}
                                                    onClick={() => {
                                                        axiosInstance.patch(`/api/v1/task/toggle-done/${record.id}`)
                                                            .then(res => {
                                                                fetchTasks();
                                                            })
                                                    }}
                                                    style={{color: 'green'}}
                                                />
                                            </Tooltip>
                                            <Tooltip
                                                placement="top"
                                                title={<span>Ukloni zadatak</span>}
                                                arrow={mergedArrow}
                                            >
                                                <Space>
                                                    <Button
                                                        type="text"
                                                        size="large"
                                                        danger
                                                        icon={<DeleteOutlined/>}
                                                        onClick={() => confirm(record.id)}
                                                    />
                                                </Space>
                                            </Tooltip>
                                        </Flex>
                                    ),
                                },
                            ]}
                            dataSource={task}
                            pagination={false}
                        ></Table>
                    </div>
                ))}
            {tableData &&
            JSON.stringify(tableData.groupedTasks) === '{}' ?
                <div style={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh'
                }}>
                    <Empty description={"Nije pronađen niti jedan zadatak."}/>
                </div> : <></>
            }
        </>
    )
}
export default TasksTable;
